import React from 'react';
import './committee-icon.css';
import { getCommitteeIconFromID } from '../../helpers/icon';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CommitteeIcon = props => {
    const { id, index, size } = props;

    const icon = getCommitteeIconFromID(id);

    const committeeIconClasses = classNames({
        'committee-icon': true,
        'committee-icon--small': size === 'small',
    });

    return (
        <img
            src={icon}
            alt={`Committee Member ${index}`}
            className={committeeIconClasses}
        />
    );
};

CommitteeIcon.defaultProps = {
    size: 'medium',
};

CommitteeIcon.propTypes = {
    id: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['small', 'medium']),
};

export { CommitteeIcon };
